/**
 * This hook is used when tracking a vehicle to control centering the map on
 * the vehicle. Using redux (see actions.js and reducer.js), it communicates
 * the on/off switch setting for centering the vehicle on the map
 */
import { useCallback } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { TRACKED_VEHICLE_CENTER_MAP_STORAGE_KEY } from '#/transit-tracker/constants';
import { trackedVehicleCenterMap } from '#/transit-tracker/slice';
import { storeItem } from '#/shared/utils/storage';

const useVehicleCentering = () => {
  const vehicleCenteringActive = useSelector(
    s => s.transitTracker.trackedVehicleCenterMap
  );
  const dispatch = useDispatch();

  const centerVehicleOnMap = useCallback(
    centered => {
      dispatch(trackedVehicleCenterMap(centered));
      storeItem(TRACKED_VEHICLE_CENTER_MAP_STORAGE_KEY, centered);
    },
    [dispatch]
  );

  return { vehicleCenteringActive, centerVehicleOnMap };
};

export default useVehicleCentering;
